module.exports = __webpack_public_path__ + "img/acabado_con_estuco_premium.43408281.png";